module.exports = __webpack_public_path__ + "images/2590c4f70fb628e93ebdfef30abe49b5.placeholder.svg";